import React from 'react';
import AmendmentTypeCard from './AmendmentTypeCard';
import { MONAMODI_AMENDMENT_OPTIONS } from '../monamodiConstants';
import { styles } from '../../styles';

const AmendmentTypeGrid = ({ onAmendmentSelect }) => {
  return (
    <div>
      <h2 style={styles.gridTitle}>
        Select Amendment Type
      </h2>
      <div style={styles.grid}>
        {MONAMODI_AMENDMENT_OPTIONS.map((option) => (
          <AmendmentTypeCard
            key={option.id}
            option={option}
            onClick={onAmendmentSelect}
          />
        ))}
      </div>
    </div>
  );
};

export default AmendmentTypeGrid;
